import React from 'react'
import Table from '../../components/common/Table'
import { FirearmSerialTypeDTO } from '../../services/apiClient'
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime'
import { renderBooleanBadge } from '../../utils/displayUtils'

interface FirearmSerialTypeTableProps {
  data: FirearmSerialTypeDTO[];
  handleEdit: (row: FirearmSerialTypeDTO) => void;
  handleDelete: (row: FirearmSerialTypeDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const FirearmSerialTypeTable: React.FC<FirearmSerialTypeTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
                
                    {
                        label: "Title",
                        key: "title",
                    },
        
                    {
                        label: "Position",
                        key: "displayPosition",
                    },
        
                    {
                        label: "Active",
                        key: "isActive",
                        render: (row: FirearmSerialTypeDTO) => renderBooleanBadge(row.isActive ?? false),
                    },
        
                {
                    label: "Added",
                    key: "createdUtc",
                    format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
                },

      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default FirearmSerialTypeTable;
